var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 11.25L18.4425 10.1925L12.75 15.8775V1.5H11.25V15.8775L5.5575 10.1925L4.5 11.25L12 18.75L19.5 11.25ZM19.5 18V21H4.5V18H3V21C3 21.8284 3.67157 22.5 4.5 22.5H19.5C20.3284 22.5 21 21.8284 21 21V18H19.5Z",
    fill: "#E20074"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download.18370ebe52b7c618b3a1f66f2b475ca2.svg";